const navigationEn = {
    "menu_editor": "Étlap",
    "settings": "Settings",
    "payment_settings": "Payment Settings",
    "user_management": "User Management",
    "logout": "Logout",
    "subscription": "Subscription",
    "new_restaurant": "Create New Restaurant",
    "privacy_policy": "Privacy Policy",
    "terms_and_conditions": "Terms and Conditions",
    "statistics": "Statistics",
    "mozrest": "Review Manager",
    "signup": "Sign Up",
};

export default navigationEn;